const React = require('react');
const isNode = (typeof process !== 'undefined');

class PropertySize extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const sizes = Array.isArray(this.props.size) ? this.props.size : [this.props.size];

        const SIZE_LABELS = [
            { name: 'primary', desc: 'Primærrom' },
            { name: 'usable', desc: 'Bruksareal' },
            { name: 'living', desc: '' },
            { name: 'gross', desc: '' },
            { name: 'floor', desc: 'Gulvareal' },
            { name: 'developed', desc: '' },
            { name: 'main', desc: 'Areal' }
        ];

        return (
            <div className="rental__fact-wrapper">
                {sizes.map(size => {
                    const sizeObj = size._attributes;
                    const def = SIZE_LABELS.find(label => label.name === sizeObj['name']);
                    const label = SIZE_LABELS.find(label => label.name === sizeObj['name']);
                    const hasRange = (!!sizeObj['from'] && !!sizeObj['to']);
                    
                    return (
                        <div className="rental__fact rental__fact--full">
                            <span className="rental__fact-header">{label.desc}</span>
                            <div className="rental__fact-value">
                                {!hasRange && <span>{sizeObj.value}m<sup>2</sup></span>}
                                {(hasRange && sizeObj['from'] !== sizeObj['to']) && <span>{sizeObj['from']}m<sup>2</sup> - {sizeObj['to']}m<sup>2</sup></span>}
                                {(hasRange && sizeObj['from'] === sizeObj['to']) && <span>{sizeObj['from']}m<sup>2</sup></span>}
                            </div>
                        </div>
                    )
                })}
            </div>
        )

    }
}

module.exports = PropertySize;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/PropertyComponents/PropertySize/index.jsx